export default __webpack_public_path__ + "static/media/hht1_direction_eggstudio_01.c56feb82.png";